// extracted by mini-css-extract-plugin
module.exports = {"expand":"button_expand__Z4xaJ","expandKeyFrame":"button_expandKeyFrame__eGTom"};